import cn from 'classnames'
import BaseModal from 'ext-ui/components/BaseModal/BaseModal'
import React, { useLayoutEffect } from 'react'
import { useDispatch } from 'react-redux'
import { closeModal } from 'src/navigation/Lnk'
import { resetModalScroll } from 'src/utils/modalScroll.utils'

import {
  POPUP_CARD_CLASS,
  POPUP_CARD_NO_PADDING_CLASS,
  PopupCardGlobalStyle,
} from './Popup.style'

interface PopupProps {
  className?: string
  noPadding?: boolean
  /** @deprecated no-op; kept for backward compatibility */
  onScroll?: (e: React.UIEvent<HTMLElement>) => void
  /** @deprecated no-op; kept for backward compatibility */
  childRef?: (node: HTMLDivElement) => void
  /** @deprecated no-op; kept for backward compatibility */
  parentRef?: (node: HTMLDivElement) => void
  onClose?: () => void
  /** Resets overlay scroll when register account changes steps. */
  registerAccount?: { currentPage?: number }
  /** Sets the `id` and `data-testid` on the close button (defaults to `closeIcon`). */
  buttonId?: string
  hideExit?: boolean
  ariaLabel?: string
}

const Popup: React.FC<React.PropsWithChildren<PopupProps>> = (
  props,
): React.ReactElement => {
  const {
    ariaLabel = 'dialog',
    hideExit,
    noPadding,
    onClose,
    className,
    buttonId,
  } = props
  const dispatch = useDispatch()

  const handleClose = (): void => {
    onClose?.()
    dispatch(closeModal())
  }

  useLayoutEffect(() => {
    if (props.registerAccount?.currentPage !== undefined) {
      resetModalScroll()
    }
  }, [props.registerAccount?.currentPage])

  // BaseModal supplies the overlay, centering, and close button; Popup supplies
  // its own white card so layout/width/padding overrides from the consumer's
  // className land on a single legacy-equivalent box.
  return (
    <>
      <PopupCardGlobalStyle />
      <BaseModal
        isOpen={true}
        onClose={handleClose}
        aria-label={ariaLabel}
        variant="popup"
        unstyledBody
        showCloseButton={!hideExit}
        closeButtonId={buttonId ?? 'closeIcon'}
        shouldCloseOnOverlayClick={!hideExit}
        shouldCloseOnEsc={!hideExit}
      >
        <div
          className={cn(POPUP_CARD_CLASS, className, {
            [POPUP_CARD_NO_PADDING_CLASS]: noPadding,
          })}
        >
          {props.children}
        </div>
      </BaseModal>
    </>
  )
}

export default Popup
